/**
 * Icon Constants
 */
var _a;
const windowPathname = window.location.pathname;
const BASE_ICON_SPRITE_PREFIX_FOR_V1 = windowPathname.includes('/v1/') && '/v1';
const BASE_ICON_SPRITE_PRIFEX = BASE_ICON_SPRITE_PREFIX_FOR_V1 ||
    (windowPathname.includes('/v2/') ? '/v2' : '');
const spriteHash = (_a = window === null || window === void 0 ? void 0 : window.blink) === null || _a === void 0 ? void 0 : _a.svgSpriteHash;
const BASE_ICON_SPRITE_SUFFIX = spriteHash ? `?v=${spriteHash}` : '';
export const BASE_ICON_SPRITE_PATH = `${BASE_ICON_SPRITE_PRIFEX}/node_modules/@thoughtspot/radiant-styles/public/img/` +
    `rd-icons/rd-icons-sprite/rd-icons.svg${BASE_ICON_SPRITE_SUFFIX}`;
export const BASE_RD_ICON_PREFIX = '#rd-icon-';
/**
 * Icon Sizes
 */
export var IconSize;
(function (IconSize) {
    IconSize["XXXSMALL"] = "xxxs";
    IconSize["XXSMALL"] = "xxs";
    IconSize["XSMALL"] = "xs";
    IconSize["SMALL"] = "s";
    IconSize["MEDIUM"] = "m";
    IconSize["LARGE"] = "l";
    IconSize["XLARGE"] = "xl";
    IconSize["XXLARGE"] = "xxl";
    IconSize["XXXLARGE"] = "xxxl";
})(IconSize || (IconSize = {}));
/**
 * Icon Colors
 *
 * Note: Text Color listens to the color of the text (CSS Property 'color') of the nearest element or ancestor element
 */
export var IconColor;
(function (IconColor) {
    /** fill → `content-primary`. Legacy name; prefer {@link IconColor.CONTENT_PRIMARY}. */
    IconColor["BLACK"] = "black";
    /** fill → `content-brand`. Legacy name; prefer {@link IconColor.CONTENT_BRAND}. */
    IconColor["BLUE"] = "blue";
    /** fill → `currentColor` — inherits the nearest text `color`. */
    IconColor["TEXT_COLOR"] = "text-color";
    /** fill → `content-inverse`. For icons on a dark/inverse surface. */
    IconColor["WHITE"] = "white";
    /** fill → `content-secondary`. Legacy name; prefer {@link IconColor.CONTENT_SECONDARY}. */
    IconColor["GRAY"] = "gray";
    /** fill → `content-success`. */
    IconColor["GREEN"] = "green";
    /** fill → `content-failure`. */
    IconColor["RED"] = "red";
    /** fill → `content-warning`. */
    IconColor["YELLOW"] = "yellow";
    /** fill → `border-subtle`. */
    IconColor["LIGHTGRAY"] = "lightgray";
    /** fill → `border-subtle`. */
    IconColor["LIGHTMEDIUMGRAY"] = "lightmediumgray";
    /** fill → `content-primary` (same as {@link IconColor.BLACK}). */
    IconColor["DARKGRAY"] = "darkgray";
    /** fill → `border-subtle`. */
    IconColor["MEDIUMGRAY"] = "mediumgray";
    /** fill → `background-accent-purple-bold`. */
    IconColor["PURPLE"] = "purple";
    /** fill → `content-information`. Fixed blue — stays blue regardless of brand theme. */
    IconColor["INFO"] = "info";
    // Semantic content-* values — preferred over the legacy literal color
    // names above; each maps 1:1 to a radiant content-* system token.
    /** fill → `content-primary`. Body text / high-emphasis icon color. */
    IconColor["CONTENT_PRIMARY"] = "content-primary";
    /** fill → `content-secondary`. Supporting / medium-emphasis icon color. */
    IconColor["CONTENT_SECONDARY"] = "content-secondary";
    /** fill → `content-tertiary`. Subtle / low-emphasis icon color. */
    IconColor["CONTENT_TERTIARY"] = "content-tertiary";
    /** fill → `content-brand`. Brand / link-colored icon. */
    IconColor["CONTENT_BRAND"] = "content-brand";
})(IconColor || (IconColor = {}));
/**
 * Icon IDs library
 * For new icons, add SVGs to `radiant-styles` at
 *   `js/ts-packages/radiant-styles/resources/img/rd-icons/`.
 */
export var IconID;
(function (IconID) {
    IconID["ABOUT"] = "about";
    IconID["ADD"] = "add";
    IconID["ADD_SELECTED"] = "add-selected";
    IconID["ADD_USER"] = "add-user";
    IconID["AGENDA"] = "agenda";
    IconID["AI"] = "ai";
    IconID["AI_SPARKLE"] = "ai-sparkle";
    IconID["AI_SPARKLE_SELECTED"] = "ai-sparkle-selected";
    IconID["ANNOTATE_ACTIVE"] = "annotate-active";
    IconID["ANNOTATE_UNREAD"] = "annotate-unread";
    IconID["ANNOTATE_RESTING"] = "annotate-resting";
    IconID["ANSWER"] = "answer";
    IconID["ANSWER_HOME"] = "answer-home";
    IconID["ANSWER_OUTLINE"] = "answer-outline";
    IconID["ARROW_DOWN"] = "arrow-down";
    IconID["ARROW_DOWN_CIRCLE"] = "arrow-down-circle";
    IconID["ARROW_LEFT"] = "arrow-left";
    IconID["ARROW_LEFT_CIRCLE"] = "arrow-left-circle";
    IconID["ARROW_RIGHT"] = "arrow-right";
    IconID["ARROW_RIGHT_CIRCLE"] = "arrow-right-circle";
    IconID["ARROW_UP"] = "arrow-up";
    IconID["ARROW_UP_CIRCLE"] = "arrow-up-circle";
    IconID["ATTRIBUTE"] = "attribute";
    IconID["A_TO_Z"] = "a-to-z";
    IconID["BACK_WHITE_CIRCLE"] = "back-white-circle";
    IconID["BELL_UNDO"] = "bell-undo";
    IconID["BLUE_ANNOTATE_RESTING"] = "blue-annotate-resting";
    IconID["BOLD"] = "bold";
    IconID["BOOK"] = "book";
    IconID["BOOK_CLOSED"] = "book-closed";
    IconID["BOOKMARK"] = "bookmark";
    IconID["BRUSH"] = "brush";
    IconID["BULB"] = "bulb";
    IconID["CARET_DOWN"] = "caret-down";
    IconID["CARET_LEFT"] = "caret-left";
    IconID["CARET_RIGHT"] = "caret-right";
    IconID["CARET_UP"] = "caret-up";
    IconID["CASE"] = "case";
    IconID["CHART"] = "chart";
    IconID["CHART_V2"] = "chart-v2";
    IconID["CHECKMARK"] = "checkmark";
    IconID["CHECKMARK_CIRCLE"] = "checkmark-circle";
    IconID["CHEVRON_DOWN"] = "chevron-down";
    IconID["CHEVRON_LEFT"] = "chevron-left";
    IconID["CHEVRON_RIGHT"] = "chevron-right";
    IconID["CHEVRON_UP"] = "chevron-up";
    IconID["CHEVRON_RIGHT_DOUBLE"] = "chevron-right-double";
    IconID["CHEVRON_LEFT_DOUBLE"] = "chevron-left-double";
    IconID["CIRCLE"] = "circle";
    IconID["CLOCK"] = "clock";
    IconID["COG"] = "cog";
    IconID["COG_WHITE"] = "cog-white";
    IconID["COMMUNITY"] = "community";
    IconID["CONDITIONAL_FORMAT"] = "conditional-format";
    IconID["COPY"] = "copy";
    IconID["CODE"] = "code";
    IconID["COPY_LINK"] = "copy-link";
    IconID["COPY_LINK_CHAIN"] = "copy-link-chain";
    IconID["CONNECTOR"] = "connector";
    IconID["CREATE_MONITOR"] = "create-monitor";
    IconID["CREATE_PINBOARD"] = "create-pinboard";
    IconID["CREATE_WORKSHEET"] = "create-worksheet";
    IconID["CREATE_WORKSHEET_V2"] = "create-worksheet-v2";
    IconID["CROSS"] = "cross";
    IconID["CROSS_CIRCLE"] = "cross-circle";
    IconID["DATA_COLUMN"] = "data-column";
    IconID["DATA_OBJECT"] = "data-object";
    IconID["DATABASE"] = "database";
    IconID["DATAROBOT"] = "datarobot";
    IconID["DEVELOP"] = "develop";
    IconID["DIVERGING_PATHS"] = "diverging-paths";
    IconID["DOC_SEARCH_EXCEL"] = "doc-search-excel";
    IconID["DOC_SEARCH_PDF"] = "doc-search-pdf";
    IconID["DOC_SEARCH_PPT"] = "doc-search-ppt";
    IconID["DOC_SEARCH_WORD"] = "doc-search-word";
    IconID["DOCUMENTATION"] = "documentation";
    IconID["DOWNLOAD"] = "download";
    IconID["DRILL_DOWN"] = "drill-down";
    IconID["EDIT_TEXT"] = "edit-text";
    IconID["EMBRACE"] = "embrace";
    IconID["EMPTY"] = "empty-icon";
    IconID["EMPTY_CELL"] = "empty-cell";
    IconID["EMPTY_CIRCLE"] = "empty-circle";
    IconID["EMPTY_CIRCLE_HOVER"] = "empty-circle-hover";
    IconID["ENTER"] = "enter";
    IconID["ESCAPE"] = "escape";
    IconID["EXCLAMATION_POINT_CIRCLE"] = "exclamation-point-circle";
    IconID["EXPAND"] = "expand";
    IconID["EYE"] = "eye";
    IconID["EYE_UNDO"] = "eye-undo";
    IconID["FOLLOW"] = "follow";
    IconID["FOLLOW_UNDO"] = "follow-undo";
    IconID["FOLLOWING"] = "following";
    IconID["FORMULA"] = "formula";
    IconID["FOUR_SQUARES"] = "four-squares";
    IconID["FULL_SCREEN"] = "full-screen";
    IconID["FULL_SCREEN_UNDO"] = "full-screen-undo";
    IconID["FUNNEL"] = "funnel";
    IconID["FUNNEL_V2"] = "funnel-v2";
    IconID["GROUP_UNDO"] = "group-undo";
    IconID["HAMBURGER"] = "hamburger";
    IconID["INSIGHTS"] = "insights";
    IconID["ILLUSTRATION"] = "illustration";
    IconID["INFORMATION"] = "information";
    IconID["INFORMATION_CIRCLE"] = "information-circle";
    IconID["ITALIC"] = "italic";
    IconID["JOIN_INNER"] = "join-inner";
    IconID["JOIN_LEFT"] = "join-left";
    IconID["JOIN_OUTER"] = "join-outer";
    IconID["JOIN_RIGHT"] = "join-right";
    IconID["KEY"] = "key";
    IconID["LIGHTNING"] = "lightning";
    IconID["LOCK"] = "lock";
    IconID["LOCK_UNDO"] = "lock-undo";
    IconID["MAGNIFYING_GLASS"] = "magnifying-glass";
    IconID["MAGNIFYING_GLASS_SMALL"] = "magnifying-glass-small";
    IconID["MANAGE_MONITOR"] = "manage-monitor";
    IconID["MEASURE"] = "measure";
    IconID["MICROPHONE"] = "microphone";
    IconID["MINUS"] = "minus";
    IconID["MONITOR"] = "monitor";
    IconID["MORE"] = "more";
    IconID["ERROR_ILLUSTRATION"] = "error-illustration";
    IconID["NAVIGATE"] = "navigate";
    IconID["NEW_TAB"] = "new-tab";
    IconID["NINE_SQUARES"] = "nine-squares";
    IconID["NO_RESULT_FOUND"] = "no-result-found";
    IconID["NOTIFICATION_BELL"] = "notification-bell";
    IconID["NOTE"] = "note";
    IconID["NUMBER_FORMAT"] = "number-format";
    IconID["PAPER_PLANE"] = "paper-plane";
    IconID["STOP_SQUARE"] = "stop-square";
    IconID["PAUSE"] = "pause";
    IconID["PENCIL"] = "pencil";
    IconID["PIN"] = "pin";
    IconID["PINBOARD"] = "pinboard";
    IconID["PINBOARD_HOME"] = "pinboard-home";
    IconID["PINBOARD_NEW"] = "pinboard-new";
    IconID["PLAY"] = "play";
    IconID["PLUS"] = "plus";
    IconID["PALETTE"] = "palette";
    IconID["PALETTE_SELECTED"] = "palette-selected";
    IconID["POPULAR_STAR"] = "popular-star";
    IconID["PRESENT"] = "present";
    IconID["PROFILE"] = "profile";
    IconID["QUESTION_MARK"] = "question-mark";
    IconID["R_ANALYSIS"] = "r-analysis";
    IconID["REDO"] = "redo";
    IconID["REPLAY_SEARCH"] = "replay-search";
    IconID["RESET"] = "reset";
    IconID["ROCKET"] = "rocket";
    IconID["SAVE"] = "save";
    IconID["SAVE_WORKSHEET"] = "save-worksheet";
    IconID["SCHEMA"] = "schema";
    IconID["SEARCH_DATA"] = "search-data";
    IconID["SHARE"] = "share";
    IconID["SHOW_UNDERLYING_DATA"] = "show-underlying-data";
    IconID["SIGN_OUT"] = "sign-out";
    IconID["SPREAD_SHEET"] = "spread-sheet";
    IconID["SPREAD_SHEET_WHITE"] = "spread-sheet-white";
    IconID["SPOTTER_MENU"] = "spotter-menu";
    IconID["SPOTTER"] = "spotter";
    IconID["SPOTTER_CODE"] = "spotter-code";
    IconID["SPOTTER_NEW"] = "spotter-new";
    IconID["SORT"] = "sort";
    IconID["STAR"] = "star";
    IconID["STAR_UNDO"] = "star-undo";
    IconID["STAR_FILLED"] = "star-filled";
    IconID["STRIKE_THROUGH"] = "strike-through";
    IconID["SYNC"] = "sync";
    IconID["TAG"] = "tag";
    IconID["TEXT"] = "text";
    IconID["TEXT_UNDO"] = "text-undo";
    IconID["THOUGHTSPOT"] = "thoughtspot";
    IconID["THOUGHTSPOT_FULL"] = "thoughtspot-full";
    IconID["THUMB_DOWN"] = "thumb-down";
    IconID["THUMB_DOWN_UNDO"] = "thumb-down-undo";
    IconID["THUMB_UP"] = "thumb-up";
    IconID["THUMB_UP_UNDO"] = "thumb-up-undo";
    IconID["TRASH_CAN"] = "trash-can";
    IconID["TRENDING_EMPTY"] = "trending-empty";
    IconID["UNDO"] = "undo";
    IconID["UPLOAD"] = "upload";
    IconID["UPLOAD_DATA"] = "upload-data";
    IconID["UNDERLINE"] = "underline";
    IconID["VIDEO"] = "video";
    IconID["WRENCH"] = "wrench";
    IconID["ZOOM_AREA"] = "zoom-area";
    IconID["CAMERA"] = "camera";
    IconID["SQL_WORKSHEET"] = "sql-worksheet";
    IconID["SQL_BASED_VIEW"] = "sql-based-view";
    IconID["SQL_TABLE"] = "sql-table";
    IconID["SQL_VIEW"] = "sql-view";
    IconID["SAGE_VIEW"] = "sage-view";
    IconID["SNOWFLAKE_CONNECTION"] = "snow-flake-connection";
    IconID["BLACK_CIRCLE"] = "black-circle";
    IconID["GREY_CIRCLE"] = "grey-circle";
    IconID["INFO_BUTTON"] = "info-button";
    IconID["MENU_ICON"] = "menu-icon";
    IconID["DRAG_HANDLE"] = "drag-handle";
    IconID["VLB_WHITE"] = "vlb-white";
    IconID["VLB_COLOR"] = "vlb-color";
    IconID["VERIFIED_WHITE"] = "verified-white";
    IconID["VERIFIED"] = "verified";
    IconID["VERIFIED_COLOR"] = "verified-color";
    IconID["VERIFIED_OUTLINE"] = "verified-outline";
    IconID["SUPER_G"] = "super-g";
    IconID["DRAG_HANDLE_V2"] = "drag-handle-v2";
    IconID["TABLE"] = "table";
    IconID["TABLE_L"] = "table-l";
    IconID["IMAGE"] = "image";
    IconID["EMBEDED"] = "embeded";
    IconID["DIVIDER"] = "divider";
    IconID["TEXT_ALIGN_RIGHT"] = "text-align-right";
    IconID["TEXT_ALIGN_LEFT"] = "text-align-left";
    IconID["TEXT_ALIGN_CENTER"] = "text-align-center";
    IconID["TEXT_ALIGN_JUSTIFY"] = "text-align-justify";
    IconID["TITLE"] = "title";
    IconID["HEADING"] = "heading";
    IconID["BULLET_LIST"] = "bullet-list";
    IconID["NUMBERED_LIST"] = "numbered-list";
    IconID["FONT_COLOR"] = "font-color";
    IconID["LINK"] = "link";
    IconID["LIVEBOARD_OUTLINE"] = "liveboard-outline";
    IconID["OPEN"] = "open";
    IconID["AI_WHITE"] = "ai-white";
    IconID["UNION_TOGGLE"] = "union";
    IconID["UNION_TOGGLE_ACTIVE"] = "union-active";
    IconID["UNION_ON_STATE"] = "union-on-state";
    IconID["SIDE_PANEL_OPEN"] = "side-panel-open";
    IconID["SIDE_PANEL_CLOSED"] = "side-panel-closed";
    IconID["TICK_SELECTION_BLUE"] = "tick-selection-blue";
    IconID["EXPORT_BY_VIZ"] = "export-by-viz";
    IconID["EXPORT_LIVEBOARD"] = "export-liveboard";
    IconID["ANALYST_STUDIO"] = "analyst-studio";
    IconID["OPEN_IN_NEW_TAB"] = "open-in-new-tab";
    IconID["LEGACY_OPEN_IN_NEW_TAB"] = "legacy-open-in-new-tab";
    IconID["OPEN_IN_NEW_TAB_BLACK"] = "open-in-new-tab-black";
    IconID["LINK_ITEM"] = "link-item";
    IconID["UNLINK_ITEM"] = "unlink-item";
    IconID["OKTA_PROVIDER"] = "okta-provider";
    IconID["GOOGLE_AUTH_PROVIDER"] = "google-auth-provider";
    IconID["EMAIL_PROVIDER"] = "email-provider";
    IconID["NOTIFICATION"] = "notification";
    IconID["TEXT_V2"] = "text-v2";
    IconID["WRAP"] = "wrap";
    IconID["PERCENT"] = "percent";
    IconID["DOLLAR"] = "dollar";
    IconID["TEXT_STYLE"] = "text-style";
    IconID["TEXT_COLOR"] = "text-color";
    IconID["PERCENTAGE"] = "percentage";
    IconID["NUMBER_FORMAT_STYLE"] = "number-format-style";
    IconID["LINE_THICKNESS"] = "line-thickness";
    IconID["SOLID_LINE"] = "solid-line";
    IconID["DASH_LINE"] = "dash-line";
    IconID["DOT_LINE"] = "dot-line";
    IconID["SQUARE"] = "square";
    IconID["TRIANGLE"] = "triangle";
    IconID["WIDTH"] = "width";
    IconID["TRIANGLE_DOWN"] = "triangle-down";
    IconID["MARKER_CIRCLE"] = "marker-circle";
    IconID["MARKER_SQUARE"] = "marker-square";
    IconID["MARKER_TRIANGLE"] = "marker-triangle";
    IconID["MARKER_DIAMOND"] = "marker-diamond";
    IconID["MARKER_TRIANGLE_DOWN"] = "marker-triangle-down";
    IconID["BACKGROUND_COLOR"] = "background-color";
    IconID["BORDER_COLOR"] = "border-color";
    IconID["CHART_TYPE_SETTINGS"] = "chart-type-settings";
    IconID["LAYOUT_SETTINGS"] = "layout-settings";
    IconID["COLUMN_SETTINGS"] = "column-settings";
    IconID["AXIS_SETTINGS"] = "axis-settings";
    IconID["DATA_LABEL_SETTINGS"] = "data-label-settings";
    IconID["TOOLTIP_SETTINGS"] = "tooltip-settings";
    IconID["LEGEND_SETTINGS"] = "legend-settings";
    IconID["DISPLAY_SETTINGS"] = "display-settings";
    IconID["ANSWER_QUERY"] = "answer-query";
    IconID["R_ANALYSIS_V2"] = "r-analysis-v2";
    IconID["CUSTOM_ACTIONS"] = "custom-actions";
    IconID["SERVICENOW"] = "servicenow";
    IconID["SALESFORCE"] = "salesforce";
    IconID["PETSPOT"] = "petspot";
    IconID["HOCKEY_STORE"] = "hockey-store";
    IconID["RETAIL_APPAREL"] = "retail-apparel";
    IconID["SALESFORCE_WHITE"] = "salesforce-white";
    IconID["PETSPOT_WHITE"] = "petspot-white";
    IconID["HOCKEY_STORE_WHITE"] = "hockey-store-white";
    IconID["RETAIL_APPAREL_WHITE"] = "retail-apparel-white";
    IconID["CONNECTOR_WHITE"] = "connector-white";
    IconID["CSV"] = "csv";
    IconID["CSV_WHITE"] = "csv-white";
    IconID["GOOGLE_SHEET"] = "google-sheet";
    IconID["GOOGLE_SHEET_WHITE"] = "google-sheet-white";
    IconID["IMPORT_DOC"] = "import-doc";
    IconID["DOC_GREEN"] = "doc-green";
    IconID["DATA_LOAD_FAILED"] = "data-load-failed";
    IconID["FILE_DEFAULT_STATE"] = "file-default-state";
    IconID["FILE_ADDED_STATE"] = "file-added-state";
    IconID["ATTACH"] = "attach";
    IconID["STYLING_PANEL_OPEN"] = "styling-panel-open";
    IconID["STYLING_PANEL_CLOSE"] = "styling-panel-close";
    IconID["ADD_TAB"] = "add-tab";
    IconID["PENCIL_LINE"] = "pencil-line";
    IconID["MOVE_TO"] = "move-to";
    IconID["SCALE"] = "scale";
    IconID["DUPLICATE"] = "duplicate";
    IconID["POINT_AND_EDIT"] = "point-and-edit";
    IconID["FILTER"] = "filter";
    IconID["GROUP_TILE"] = "group-tile";
    IconID["NOTE_TILE"] = "note-tile";
    IconID["TRASH_CAN_LINE"] = "trash-can-line";
    IconID["GROUP"] = "group";
    IconID["UPDOWN_ARROW"] = "updown-arrow";
    IconID["UNGROUP"] = "ungroup";
    IconID["TEXT_STYLING"] = "text-styling";
    IconID["DENSITY_TIGHT"] = "density-tight";
    IconID["DENSITY_REGULAR"] = "density-regular";
    IconID["DENSITY_LOOSE"] = "density-loose";
    IconID["DENSITY_TIGHT_ACTIVE"] = "density-tight-active";
    IconID["DENSITY_REGULAR_ACTIVE"] = "density-regular-active";
    IconID["DENSITY_LOOSE_ACTIVE"] = "density-loose-active";
    IconID["CORNER_SHARP"] = "corner-sharp";
    IconID["CORNER_CURVED"] = "corner-curved";
    IconID["CORNER_SHARP_ACTIVE"] = "corner-sharp-active";
    IconID["CORNER_CURVED_ACTIVE"] = "corner-corved-active";
    IconID["LB_GUTTERED"] = "lb-guttered";
    IconID["LB_GUTTERED_ACTIVE"] = "lb-guttered-active";
    IconID["LB_GUTTERLESS"] = "lb-gutterless";
    IconID["LB_GUTTERLESS_ACTIVE"] = "lb-gutterless-active";
    IconID["DATA_WORKSPACE"] = "data-workspace";
    IconID["LOCK_GREY"] = "lock-grey";
    IconID["ADD_NOTE_OUTLINE"] = "add-note-outline";
    IconID["ADD_TAB_OUTLINE"] = "add-tab-outline";
    IconID["FILTER_OUTLINE"] = "filter-outline";
    IconID["GROUP_OUTLINE"] = "group-outline";
    IconID["PARAMETER"] = "parameter";
    IconID["SOURCE_TABLE"] = "source-table";
    IconID["SET"] = "set";
    IconID["CALENDAR"] = "calendar";
    IconID["PANEL_OPEN"] = "panel-open";
    IconID["PANEL_CLOSE"] = "panel-close";
    IconID["ORANGE_GITHUB"] = "orange-github";
    IconID["YOUTUBE"] = "youtube";
    IconID["CHAT"] = "chat";
    IconID["EXPAND_SCREEN"] = "expand-screen";
    IconID["COLLAPSE_SCREEN"] = "collapse-screen";
    IconID["SPOTTER_DEEP_ANALYSIS_MODE"] = "deep-analysis";
    IconID["SPOTTER_MODE"] = "spotter-mode";
    IconID["TABLE_WRAP"] = "table-wrap";
    IconID["TABLE_CLIP"] = "table-clip";
    IconID["ANSWER_V2"] = "answer-v2";
    IconID["ANSWER_V3"] = "answer-v3";
    IconID["LIVEBOARD_V2"] = "pinboard-v2";
    IconID["SPOTTER_V2"] = "spotter-v2";
    IconID["SAGE_V2"] = "sage-v2";
    IconID["FULLAPP_V2"] = "fullapp-v2";
    IconID["SEARCH_V2"] = "search-v2";
    IconID["WORKSHEET_FORMAT"] = "worksheet-format";
    IconID["STACKBLITZ"] = "stackblitz";
    IconID["DATA_SOURCE"] = "data-source";
    IconID["COLLECTION"] = "collection";
    IconID["COLLECTION_ALERT"] = "collectionalert";
    IconID["SPOTTER_TOOLS"] = "spotter-tools";
    IconID["SPOTTER_VIZ"] = "spotter-viz";
    IconID["SPOTTER_VIZ_ONBOARDING"] = "spotter-viz-onboarding";
    IconID["CHART_ADVANCED_PIVOT_TABLE"] = "chart-advanced-pivot-table";
    IconID["CHART_ADVANCED_COLUMN"] = "chart-advanced-column";
    IconID["CHART_ADVANCED_STACKED_COLUMN"] = "chart-advanced-stacked-column";
    IconID["CHART_ADVANCED_BAR"] = "chart-advanced-bar";
    IconID["CHART_ADVANCED_STACKED_BAR"] = "chart-advanced-stacked-bar";
    IconID["CHART_ADVANCED_LINE"] = "chart-advanced-line";
    IconID["CHART_ADVANCED_AREA"] = "chart-advanced-area";
    IconID["CHART_ADVANCED_STACKED_AREA"] = "chart-advanced-stacked-area";
    IconID["CHART_ADVANCED_LINE_COLUMN"] = "chart-advanced-line-column";
    IconID["CHART_ADVANCED_LINE_STACKED_COLUMN"] = "chart-advanced-line-stacked-column";
    IconID["CHART_MUZE_AREA"] = "chart-muze-area";
    IconID["CHART_MUZE_BAR"] = "chart-muze-bar";
    IconID["CHART_MUZE_BUBBLE"] = "chart-muze-bubble";
    IconID["CHART_MUZE_CANDLESTICK"] = "chart-muze-candlestick";
    IconID["CHART_MUZE_COLUMN"] = "chart-muze-column";
    IconID["CHART_MUZE_PIE"] = "chart-muze-pie";
    IconID["CHART_MUZE_FUNNEL"] = "chart-muze-funnel";
    IconID["CHART_MUZE_GEO_AREA"] = "chart-muze-geo-area";
    IconID["CHART_MUZE_GEO_BUBBLE"] = "chart-muze-geo-bubble";
    IconID["CHART_MUZE_GEO_HEATMAP"] = "chart-muze-geo-heatmap";
    IconID["CHART_MUZE_HEATMAP"] = "chart-muze-heatmap";
    IconID["CHART_MUZE_KPI"] = "chart-muze-kpi";
    IconID["CHART_MUZE_LINE"] = "chart-muze-line";
    IconID["CHART_MUZE_LINE_COLUMN"] = "chart-muze-line-column";
    IconID["CHART_MUZE_LINE_STACKED_COLUMN"] = "chart-muze-line-stacked-column";
    IconID["CHART_MUZE_MUZE_STUDIO"] = "chart-muze-muze-studio";
    IconID["CHART_MUZE_PARETO"] = "chart-muze-pareto";
    IconID["CHART_MUZE_PIVOT_TABLE"] = "chart-muze-pivot-table";
    IconID["CHART_MUZE_ADVANCED_PIVOT_TABLE"] = "chart-muze-advanced-pivot-table";
    IconID["CHART_MUZE_SPIDER_WEB"] = "chart-muze-spider-web";
    IconID["CHART_MUZE_SANKEY"] = "chart-muze-sankey";
    IconID["CHART_MUZE_SCATTER"] = "chart-muze-scatter";
    IconID["CHART_MUZE_STACKED_AREA"] = "chart-muze-stacked-area";
    IconID["CHART_MUZE_STACKED_BAR"] = "chart-muze-stacked-bar";
    IconID["CHART_MUZE_STACKED_COLUMN"] = "chart-muze-stacked-column";
    IconID["CHART_MUZE_TREEMAP"] = "chart-muze-treemap";
    IconID["CHART_MUZE_WATERFALL"] = "chart-muze-waterfall";
    IconID["CHART_AREA"] = "chart-area";
    IconID["CHART_BAR"] = "chart-bar";
    IconID["CHART_BUBBLE"] = "chart-bubble";
    IconID["CHART_CANDLESTICK"] = "chart-candlestick";
    IconID["CHART_COLUMN"] = "chart-column";
    IconID["CHART_CUSTOM_CHART"] = "chart-custom-chart";
    IconID["CHART_DATA_TABLE_COLORED"] = "chart-data-table-colored";
    IconID["CHART_DATA_TABLE"] = "chart-data-table";
    IconID["CHART_FUNNEL"] = "chart-funnel";
    IconID["CHART_GEO_AREA"] = "chart-geo-area";
    IconID["CHART_GEO_BUBBLE"] = "chart-geo-bubble";
    IconID["CHART_GEO_HEATMAP"] = "chart-geo-heatmap";
    IconID["CHART_HEADLINE"] = "chart-headline";
    IconID["CHART_HEATMAP"] = "chart-heatmap";
    IconID["CHART_HISTOGRAM"] = "chart-histogram";
    IconID["CHART_IMPORTED_DATA_TABLE"] = "chart-imported-data-table";
    IconID["CHART_KPI"] = "chart-kpi";
    IconID["CHART_LINE_COLUMN"] = "chart-line-column";
    IconID["CHART_LINE_STACKED_COLUMN"] = "chart-line-stacked-column";
    IconID["CHART_LINE"] = "chart-line";
    IconID["CHART_LOADING_CHART"] = "chart-loading-chart";
    IconID["CHART_MUZE_STUDIO"] = "chart-muze-studio";
    IconID["CHART_PARETO"] = "chart-pareto";
    IconID["CHART_PIE_OLD"] = "chart-pie-old";
    IconID["CHART_PIE"] = "chart-pie";
    IconID["CHART_PIVOT_TABLE"] = "chart-pivot-table";
    IconID["CHART_RADAR_MULTI"] = "chart-radar-multi";
    IconID["CHART_SANKEY"] = "chart-sankey";
    IconID["CHART_SCATTER"] = "chart-scatter";
    IconID["CHART_SPIDER_WEB"] = "chart-spider-web";
    IconID["CHART_SPOTIQ_ANOMALY_LESS"] = "chart-spotiq-anomaly-less";
    IconID["CHART_SPOTIQ_ANOMALY_MORE"] = "chart-spotiq-anomaly-more";
    IconID["CHART_SPOTIQ_BAR_LESS"] = "chart-spotiq-bar-less";
    IconID["CHART_SPOTIQ_BAR_MORE"] = "chart-spotiq-bar-more";
    IconID["CHART_SPOTIQ_COLUMN_LESS"] = "chart-spotiq-column-less";
    IconID["CHART_SPOTIQ_COLUMN_MORE"] = "chart-spotiq-column-more";
    IconID["CHART_SPOTIQ_CORRELATION_COLUMN_NEGATIVE"] = "chart-spotiq-correlation-column-negative";
    IconID["CHART_SPOTIQ_CORRELATION_COLUMN_POSITIVE"] = "chart-spotiq-correlation-column-positive";
    IconID["CHART_SPOTIQ_CORRELATION_LINE_NEGATIVE"] = "chart-spotiq-correlation-line-negative";
    IconID["CHART_SPOTIQ_CORRELATION_LINE_POSITIVE"] = "chart-spotiq-correlation-line-positive";
    IconID["CHART_SPOTIQ_DONUT_LESS"] = "chart-spotiq-donut-less";
    IconID["CHART_SPOTIQ_DONUT_MORE"] = "chart-spotiq-donut-more";
    IconID["CHART_SPOTIQ_SCATTER_LESS"] = "chart-spotiq-scatter-less";
    IconID["CHART_SPOTIQ_SCATTER_MORE"] = "chart-spotiq-scatter-more";
    IconID["CHART_SPOTIQ_TREND_LINE_DOWNWARD"] = "chart-spotiq-trend-line-downward";
    IconID["CHART_SPOTIQ_TREND_LINE_UPWARD"] = "chart-spotiq-trend-line-upward";
    IconID["CHART_SPOTIQ_TREND_LINE_ZERO"] = "chart-spotiq-trend-line-zero";
    IconID["CHART_SPOTIQ_TREND_SCATTER_DOWNWARD"] = "chart-spotiq-trend-scatter-downward";
    IconID["CHART_SPOTIQ_TREND_SCATTER_UPWARD"] = "chart-spotiq-trend-scatter-upward";
    IconID["CHART_SPOTIQ_TREND_SCATTER_ZERO"] = "chart-spotiq-trend-scatter-zero";
    IconID["CHART_STACKED_AREA"] = "chart-stacked-area";
    IconID["CHART_STACKED_BAR"] = "chart-stacked-bar";
    IconID["CHART_STACKED_COLUMN"] = "chart-stacked-column";
    IconID["CHART_TABLE"] = "chart-table";
    IconID["CHART_TREEMAP"] = "chart-treemap";
    IconID["CHART_WATERFALL"] = "chart-waterfall";
    IconID["CHART_WORKSHEET"] = "chart-worksheet";
    IconID["NEW_CHEVRON_RIGHT"] = "new-chevron-right";
    IconID["FLIP_ARROWS"] = "flip-arrows";
    IconID["LEFT_PANEL_OPEN"] = "left-panel-open";
    IconID["LEFT_PANEL_CLOSE"] = "left-panel-close";
    IconID["DEFAULT_FILE"] = "default-file";
    IconID["IMAGE_THUMBNAIL"] = "image-thumbnail";
    IconID["DOUBLE_CHECK"] = "double-check";
    IconID["CURIOUS"] = "curious";
    IconID["FOLLOW_UP"] = "follow-up";
    IconID["AI_PENCIL_LINE"] = "ai-pencil-line";
    IconID["USER_GROUP"] = "user-group";
})(IconID || (IconID = {}));
//# sourceMappingURL=icon-constants.js.map